import React, { useEffect, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Button, Stack, styled } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../componentsPeopletech/Footer/Footer';

const ComingSoonService = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const baseUrl = 'https://www.peoplefortech.com';
  const currentLang = i18n.language || 'en';

  // Scroll al inicio cuando se carga la página (useLayoutEffect se ejecuta antes del render)
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  // También en useEffect por si acaso
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  const serviceKey = (location.state && location.state.serviceKey) || 'consultory';

  const serviceTitleMap = {
    consultory: 'services.consultory.title',
    development: 'services.development.title',
  };

  const serviceTitle = t(serviceTitleMap[serviceKey] || 'services.consultory.title');

  const BackgroundVideoContainer = styled(Box)({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.85)',
      zIndex: 1,
    },
  });

  const Video = styled('video')({
    position: 'absolute',
    top: '50%',
    left: '50%',
    minWidth: '100%',
    minHeight: '100%',
    width: 'auto',
    height: 'auto',
    transform: 'translate(-50%, -50%)',
    filter: 'blur(5px)',
    objectFit: 'cover',
    zIndex: 0,
    opacity: 1,
  });

  const ContentWrapper = styled(Box)({
    position: 'relative',
    zIndex: 1,
    backgroundColor: 'transparent',
  });

  return (
    <>
      <Helmet>
        <title>{`${serviceTitle} - ${t('comingSoon.title')}`}</title>
        <meta name="description" content={t('comingSoon.text')} />
        <link rel="canonical" href={`${baseUrl}/coming-soon`} />
        <html lang={currentLang} />
      </Helmet>

      <BackgroundVideoContainer>
        <Video
          autoPlay
          loop
          muted
          playsInline
          src="/18192389-hd_1920_1080_60fps.mp4"
        >
          Tu navegador no soporta la reproducción de videos.
        </Video>
      </BackgroundVideoContainer>

      <ContentWrapper>
        <Container maxWidth="md" sx={{ py: 10 }}>
          <Stack spacing={5} alignItems="center" textAlign="center">
            <Box>
              <Typography
                variant="h3"
                component="h1"
                gutterBottom
                sx={{ fontWeight: 700, color: 'black', mb: 1 }}
              >
                {serviceTitle}
              </Typography>
              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                sx={{ fontWeight: 800, letterSpacing: 2, color: 'black' }}
              >
                {t('comingSoon.title')}
              </Typography>
            </Box>

            <Typography
              variant="body1"
              sx={{ fontSize: '1.1rem', maxWidth: 600, color: '#333', lineHeight: 1.8 }}
            >
              {t('comingSoon.text')}
            </Typography>

            <Button
              variant="contained"
              size="large"
              className="glow-on-hover"
              onClick={() => navigate('/contact')}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                backgroundColor: '#000000',
                color: '#ffffff',
                borderRadius: 10,
                boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
                '&:hover': {
                  backgroundColor: '#333333',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                },
              }}
            >
              {t('seoExample.contactUs')}
            </Button>
          </Stack>
        </Container>

        <Footer />
      </ContentWrapper>
    </>
  );
};

export default ComingSoonService;



